export class Requests {
    constructor(Assistent) {
        this.assistent = Assistent;
    }

    post(url, data) {
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
            body: JSON.stringify(data),
        });
    }

    get(url) {
        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
        });
    }

    loadConfiguration() {
        // define configuration structure for type hinting
        this.assistent.configuration = {
            routes: {
                translator: undefined,
                rewriter: undefined,
                spellcheck: undefined
            }
        };

        // get the configuration from local storage if it exists
        let configuration = getConfigurationFromLocalStorage();
        if (configuration) {
            this.assistent.configuration = configuration;
            return;
        }

        this.get(this.assistent.getAttribute('data-config-url'), null, 'GET')
            .then(async (response) => {
                if (response.status !== 200) {
                    throw new Error('Failed to load configuration');
                }

                let data = await response.json();
                data.expires_at = Date.now() + 1000 * 60 * 60; // 1 hour

                // store in local storage
                localStorage.setItem('compass-assistent-configuration', JSON.stringify(data));
                this.assistent.configuration = data;
            });

        function getConfigurationFromLocalStorage() {
            let configuration = localStorage.getItem('compass-assistent-configuration');

            if (!configuration) {
                return;
            }

            configuration = JSON.parse(configuration);
            if (configuration.expires_at < Date.now()) {
                return;
            }

            return configuration;
        }
    }
}
